<template>
    <div>
          <Mainlayout></Mainlayout>
        <CCol sm="12" style="width: 80%;background-size: cover; margin: auto;">
        <div>
            <br /> <br /> <br /><br />
            <CCard class="p-20 font-color-171717 m-2">
                <CRow class="m-3 p-20">
                    <CCol sm="12">
                        <iframe :src="questionVideo.Url" frameborder="0" allowfullscreen style="width: 100%;height:450px"></iframe>
                        <CRow>
                            <CCol sm="6"> <label class="ml-2 mr-2 mt-2">Current Video Question :{{ questionVideo.IndexNo }}</label></CCol>
                            <CCol sm="6"> <span class="custom-border-purple p-2 text-center text-white" @click="nextQuestion(questionVideo.IndexNo, questionVideo.SessionId)">
                                 <label class="ml-2 mr-2 mt-2">Next Video</label></span></CCol>
                        </CRow>
                        <h4 class="mt-2">Question:</h4>
                        <p>{{ questionVideo.Question }}</p>
                        <h4 class="mt-3">Answer:</h4>
                        <!-- <p>{{ questionVideo.Answer }}</p> -->
                        <p class="custom-12px-400" v-html="formattedAnswer"></p>

                    </CCol>
                    <CRow id="printsection">
                    <CCol sm="5">
    
                        <h3 class="custom-18px-500 font-inter mt-2">
                            4 personal character indicators
                        </h3>
    
                        <CCard>
                            <CRow>
                                <CCol v-if="report === 'Not available yet.'" sm="6">
                                    <CRow class="text-center m-0">
                                        <CChartDoughnut :datasets="defaultDatasets" />
                                        <br />
                                        <span class="text-center ml-2">No data available.</span>
                                    </CRow>
    
                                </CCol>
    
                                <CCol v-else sm="6" v-for="(dataset, index) in datasets" :key="index">
                                    <div class="text-center">
                                        <CChartDoughnut :datasets="[dataset]" :labels="[dataset.label]" :options="chartOptions" />
    
                                    </div>
                                </CCol>
    
    
    
                            </CRow>
                        </CCard>
    
                        <CCard>
                            <h3 class="custom-14px-400 font-inter m-2">Overall performance</h3>
                            <br />
                            <CChartRadar
      :datasets="radarChartData.datasetsRadar"
      :options="responsive"
      :labels="radarChartData.labels"
    />
    <br /><br />
                        </CCard>
    
                   
    
    
                    </CCol>
                    <CCol sm="7">
    
                        <CCol sm="12">
    
    
                            <h3 class="custom-18px-500 font-inter mt-2">Detail Explanation & Score</h3>
                            <h3 class="custom-14px-400 font-inter">Ranked based on users answer</h3>
                            <CCard>
    
                                <CRow class="m-2">
                                    <CCol v-if="report === 'Not available yet.'" sm="6">
                                        <p>No data available.</p>
                                    </CCol>
                                    <CCol v-else sm="6" v-for="(trait, index) in report" :key="index">
                                        <div>
    
                                            <CRow class="mt-2">
                                                <CCol sm="8">
                                                    <h4 class="custom-18px-600 font-color-171717 font-inter">{{ trait.Type }}</h4>
                                                </CCol>
                                                <CCol sm="4">
                                                    <h4 class="custom-16px-500 font-color-171717 font-inter">{{ trait.Value }} /10</h4>
                                                </CCol>
    
                                                <CCol sm="12">
                                                    <p class="custom-14px-400 mt-2 font-color-171717">{{ trait.Details }}</p>
                                                </CCol>
                                                <CCol sm="12">
                                                    <!-- <progress :value="trait.Value" max="10" show-percentage style="width:100%"></progress> -->
                                                    <CProgress :value="trait.Value" show-percentage color="success" max="10" :animated="animate" class="mb-2" />
                                                </CCol>
                                            </CRow>
                                        </div>
                                    </CCol>
                                </CRow>
    
                            </CCard>
    
    
                        </CCol>
                    </CCol>
                    <CCol sm="12">
                        <h3 class="custom-16px-600">Summary</h3>
                        <h4 class="custom-18px-400" v-if="reportSummary != null">
                            <pre>{{ reportSummary }}</pre>
                        </h4>
                    </CCol>
                    </CRow>
                    <CCol sm="6"> <label class="custom-border-purple-white p-2 mr-2 font-color-928AFD text-center mt-5 mb-5" style="width:100%" v-on:click="PrintSectionInvoice"><img style="width:20px" src="../assets/img/Download.png" />Download</label></CCol>
                    <CCol sm="6"> <label class="custom-border-purple p-2 mr-2 text-white text-center mt-5 mb-5" style="width:100%">Continue</label></CCol>
    
                </CRow>
            </CCard>
        </div>
        </CCol>
    </div>
</template>



<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bg.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundMap from "../assets/img/Map.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import backgroundUrNoArrow from "../assets/img/bgline.png";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { CChartDoughnut } from '@coreui/vue-chartjs';
import { CCol } from '@coreui/vue';
import html2pdf from 'html2pdf.js';
import { CChartRadar } from '@coreui/vue-chartjs';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        PulseLoader,
        CChartDoughnut,
        CCol,
        CChartRadar,
        html2canvas,
        jsPDF
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundMap,
            backgroundUrNoArrow,
            ispopupVisible2: false,
            ispopupVisible3: false,
            user: {},
            videoUrl: '',
            searchQuery: '',

            questionVideo: {},
            Busy: false,
            report: [],
            reportRank: [],
            reportSummary: '',
            datasets: [],
            maxScore: 10, // Maximum score possible
            max: 10,
            chartOptions: {
                plugins: {
                    legend: {
                        display: true,
                        position: 'bottom', // Place legend at the bottom
                        labels: {
                            fontColor: 'black', // Adjust font color as needed
                            fontSize: 14,
                        },
                    },
                    doughnutBackgrounds: {
                        colors: [
                            { backgroundColor: 'rgba(0, 0, 0, 0.1)' }, // Example background color
                        ],
                    },
                    tooltip: {
                        enabled: true, // Enables tooltip
                        callbacks: {
                            label: function(context) {
                                // Display only value inside the tooltip
                                const value = context.raw || 0;
                                return `${value}`;
                            },
                        },
                    },
                    datalabels: {
                        display: function(context) {
                            // Show datalabels only for the value part
                            return context.dataIndex === 0;
                        },
                        formatter: function(value) {
                            return value; // Display the value
                        },
                        color: '#000', // Set text color
                        font: {
                            size: 14, // Set font size
                            weight: 'bold', // Set font weight
                        },
                    },
                },
            },
            fields: [{
                    key: 'CandidateName'
                }, {
                    key: 'Email'
                },
                {
                    key: 'Interview'
                }, {
                    key: 'Video'
                },
            ],
            currentPage: 1,
            itemsPerPage: 10,
            sessionId: this.$route.query.code,
            session: {},

            radarChartData: {
                labels: ['Type1', 'Type2', 'Type3'],
                datasetsRadar: [{
                    label: 'AI Video Score',
                    backgroundColor: 'rgba(145, 138, 246, 0.25)',
                    borderColor: 'rgba(113, 100, 169, 1)',
                    data: []
                }]
            },
            defaultOptionsRadar: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    r: {
                        beginAtZero: true,
                        min: 1,
                        suggestedMax: 10,
                        ticks: {
                            stepSize: 1,
                            callback: function(value) {
                                // Exclude the label for 0 but ensure scale starts at 0
                                //  return value === 0 ? '' : value;
                            }
                        },
                        grid: {
                            circular: true
                        },
                        pointLabels: {
                            display: true,
                            centerPointLabels: true
                        }
                    }
                }
            },
        };
    },
    created() {},
    computed: {
        formattedAnswer() {
            // Replace the newline characters with <br> for HTML rendering
            return this.questionVideo.Answer.replace(/\n/g, '<br>');
        }
    },


    async mounted() {
        try {
            const isAuth = await this.UserAuth();
            if (isAuth) {
                this.GetInfoUser(); // Fetch the user details first
                this.GetSession(this.$route.query.id);
                //this.openVideoPopup(this.sessionId);

            } else {
                this.GoToPage();
            }
        } catch (error) {
            this.GoToPage();
            console.error("Error during authentication:", error);
            // Handle the error here
        }

    },
    methods: {
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async GetSession(code) {
            try {
                const response = await this.$API.get(this.$GetSessionId + "?code=" + code);
                if (response.status === 200) {
                    this.session = response.data;
                    this.openVideoPopup(this.session);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },


        openVideoPopup(sessionId) {
            this.getReport(sessionId);
            this.getReportRank(sessionId);
            this.getReportSummaryRank(sessionId);
            this.getListQuestion(1, sessionId);
            this.getReportRadar(sessionId);
        },

        // Method to close the video popup

        async nextQuestion(index, sessionId) {
            this.index++;
            this.index1 = index + 1;
            this.showVideo = false;
            console.log("index" + this.index1);
            this.getListQuestion(this.index1, sessionId);

        },
        async getListQuestion(index, sessionId) {
            try {
                const response = await this.$API.get(
                    `${this.$GetNextQuestionVideo}/${sessionId}/${index}`, {
                        withCredentials: true,
                    }
                );
                if (response.status === 200) {
                    this.questionVideo = response.data;
                } else {

                }
            } catch (error) {}

        },
        async getReport(sessionId) {
            try {
                const response = await this.$API.get(this.$GetRank + "?session_id=" + sessionId);
                if (response.status === 200) {
                    this.report = response.data;
                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        async getReportRadar(sessionId) {
            try {
                const response = await this.$API.get(this.$GetRank + "?session_id=" + sessionId);
                if (response.status === 200) {
                    this.reportRadar = response.data;
                    this.processReportData(this.report);
                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        processReportData() {
            // Extract Type and Value for labels and data
            this.radarChartData.labels = this.reportRadar.map(item => item.Type);
            this.radarChartData.datasetsRadar[0].data = this.reportRadar.map(item => item.Value); // Include 0 for proper scaling
        },
//         processReportData() {
//     // Extract Type and Value for labels and data
//     this.radarChartData.labels = this.reportRadar.map(item => item.Type);

//     // Store radar data values
//     const radarData = this.reportRadar.map(item => item.Value);

//     // Add a 0 to the start, but make sure the first value does not connect to 0
//     // Instead of using null, we will directly manage the line connection.
//     const chartData = [0, ...radarData];  // Start with 0

//     // Set the radar chart data
//     this.radarChartData.datasetsRadar[0].data = chartData.slice(0);

//     // Add radar chart options to ensure the axis starts at 0 and manage line connections
//     this.radarChartOptions = {
//         scales: {
//             r: {
//                 min: 0,            // Ensure axis starts at 0
//                 beginAtZero: true,  // Visual axis start at 0
//                 ticks: {
//                     display: true,  // Display the ticks on the axis
//                     stepSize: 1,    // Optional: Adjust tick step size
//                 }
//             }
//         },
//         elements: {
//             line: {
//                 fill: false,        // Do not fill the area under the line
//                 spanGaps: true,     // Prevent the line from connecting through null values
//                 borderJoinStyle: 'round', // Smooth out the edges of the line
//             }
//         }
//     };
// },
        async getReportRank(sessionId) {
            try {
                const response = await this.$API.get(this.$GetRank + "?session_id=" + sessionId);
                if (response.status === 200) {
                    const relevantTypes = ['Attitude', 'Communication', 'Sociability', 'Teamwork'];
                    this.reportRank = response.data;
                    console.log("rank" + this.reportRank);
                    this.prepareChartData(this.reportRank);
                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        async getReportSummaryRank(sessionId) {
            try {
                const response = await this.$API.get(this.$SessionSummary + "?session_id=" + sessionId);
                if (response.status === 200) {
                    this.reportSummary = this.reformatSummary(response.data.Summary);
                } else {
                    // Handle non-200 status code
                    this.reportSummary = null;
                }
            } catch (error) {
                // Handle the error here
                this.reportSummary = null;
            }
        },
        reformatSummary(summaryText) {
            return summaryText ? summaryText.replace(/:/g, ':\n') : null;
        },
        prepareChartData() {
            const relevantCategories = ['Attitude', 'Communication', 'Sociability', 'Teamwork'];
            const maxScore = 10;

            this.datasets = this.reportRank
                .map(trait => ({
                    data: [trait.Value * 10, (maxScore - trait.Value) * 10],
                    backgroundColor: ['#928AFD', '#E0E0E0'],
                    label: trait.Type
                }));
        },
        GoToPage() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/Login") {

                this.$router.push({
                    path: '/Login',
                    query: {
                        targetUrl: this.$router.currentRoute.fullPath,
                    }
                })

            }
        },
        PrintSectionInvoice() {
    const printSection = document.getElementById('printsection');
    
    html2canvas(printSection, {
        scale: 2,
        useCORS: true,
    }).then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF({
            orientation: 'portrait',
            unit: 'pt',
            format: 'a4',
        });

        const margin = 30; // Margin around the content
        const imgWidth = 595.28 - 2 * margin; // A4 width in points minus margins
        const imgHeight = (canvas.height * imgWidth) / canvas.width; // Calculate height based on width
        let heightLeft = imgHeight;
        let position = margin;

        // Add the image to the first page
        pdf.addImage(imgData, 'PNG', margin, position, imgWidth, imgHeight);
        heightLeft -= (841.89 - 2 * margin); // Subtract the page height minus margins

        // Add additional pages if necessary
        while (heightLeft > 0) {
            position = heightLeft - imgHeight;
            pdf.addPage();
            pdf.addImage(imgData, 'PNG', margin, position, imgWidth, imgHeight);
            heightLeft -= (841.89 - 2 * margin); // Subtract the page height minus margins
        }

        pdf.save('download.pdf');
    });
},

    }

};
</script>

<style scoped>
pre {
    white-space: pre-wrap;
    /* Ensures that newlines and spaces are rendered as expected */
    color: #171717;
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    /* 27px */
}
.copy-notification {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #4CAF50;
  color: white;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0,0,0,0.5);
  z-index: 1000;
}
</style>
